module.exports = __webpack_public_path__ + "media/images/admin/icons/inbox-ecc13d6312bef146aef062fc394ab4b7.svg";